import { Box, styled, spacing, Modal, Text, UiState, palette, themeMode, fontSize } from '@landr/maestro';
import { PrismicHTML } from 'components/Prismic';

export const StyledPricingTable = styled(Box)`
    position: relative;
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 -${spacing('md')};
    width: calc(100% + 2 * ${spacing('md')});

    ${({ theme }) => theme.breakpoint('md')`
        flex-direction: column;
    `}
`;

export const StyledLink = styled(Box)`
    margin: 0;
    padding: 0;
    a {
        text-decoration: none;
    }
`;

export const StyledPricingModal = styled(Modal)`
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
`;

export const StyledPricingContentBox = styled(Box)`
    flex: 1 1 0;
    justify-content: center;
    max-width: 100%;
    padding-right: 10%;
    padding-left: 10%;
    ${({ theme }) => theme.breakpoint('xl')`
        padding-right: 5%;
        padding-left: 5%;
    `}
    ${({ theme }) => theme.breakpoint('md')`
        padding: ${spacing('md')};
    `}
`;

export const StyledPricingTabContent = styled(Box)`
    display: flex;
    justify-content: center;
    margin-top: 26px;
    ${({ theme }) => theme.breakpoint('md')`
        flex-direction: column;
        margin-top: 0px;
    `}
`;

export const StyledPricingTabPlans = styled(Box)`
    display: flex;
    flex-direction: row;
    ${({ theme }) => theme.breakpoint('md')`
        flex-direction: column;
    `}
`;

export const StyledPlan = styled(Box)<{ isDisabled?: boolean; isLarge?: boolean; isFeatured?: boolean }>`
    theme: dark;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid;
    border-color: ${themeMode({ light: palette('neutral.200'), dark: palette('neutral.700') })};
    border-radius: 4px;
    flex-grow: 1;
    margin: ${spacing('sm')};
    padding: ${spacing('xl')};
    ${({ isFeatured, theme }) =>
        isFeatured &&
        `
        margin-top:-20px;
        background-color:${theme.palette.platinum[800]};
    `}
    ${({ theme }) => theme.breakpoint('md')`
        width: calc(100% - 2 * ${spacing('md')});
        padding: ${theme.spacing(10)} 0;
        flex-basis: unset;
        margin-top:0px;
    `};

    ${({ isDisabled, theme }) =>
        isDisabled &&
        `
        background: transparent;
        color: ${theme.palette.neutral[300]}
  `}
`;

export const StyledFeaturedPrice = styled(Box)`
    text-decoration: line-through;
`;

export const StyledPlanName = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const StyledPlanPrice = styled(Text)`
    font-size: ${fontSize('jb')};
    ${({ theme }) => theme.breakpoint('lg')`
        font-size: ${fontSize('xxl')};
    `};
`;

export const StyledPlanDescription = styled(PrismicHTML)`
    flex: 0 0 auto;
    margin-top: ${spacing('sm')};
    text-align: center;
    height: 40px;
    max-height: 40px;
    color: ${palette('neutral.400')};
    ${({ theme }) => theme.breakpoint('xl')`
        font-size: ${spacing('sm')};
    `};
`;

export const StyledPlanDetails = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: ${spacing('lg')};
`;

export const StyledPlanFeatures = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const StyledPlanDetailsList = styled(Box)`
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const StyledPlanDetailsListItem = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-right: ${spacing('md')};
    padding-left: ${spacing('md')};
    padding-top: ${spacing('xs')};
    padding-bottom: ${spacing('xs')};
    white-space: nowrap;
`;

export const StyledProductPrice = styled(Text)`
    size: ${spacing('md')};
    margin-left: ${spacing('xs')};
    font-weight: normal;
`;

export const StyledUiStateError = styled(UiState)`
    border: 1px solid;
    border-color: ${themeMode({ light: palette('neutral.200'), dark: palette('neutral.700') })};
    border-radius: 4px;
    padding: ${spacing('xl')};
`;

export const StyledUiStateErrorContent = styled(UiState.Content)`
    color: ${palette('neutral.1000')};
    font-size: ${spacing('sm')};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
